import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DirectoryService} from '../core/application-settings/repository-manager/directory.service';
import {ErrorPromptComponent} from '../shared/error-prompt/error-prompt.component';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.less']

})
export class GuideComponent {

  done = false;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: string,
              public ds: DirectoryService,
              private dialog: MatDialog,
              private dialogRef: MatDialogRef<GuideComponent>) {

    let fileName = this.dialogData;
    
    // S'assurer que le fichier a l'extension .pdf
    if (!fileName.toLowerCase().endsWith('.pdf')) {
      fileName = fileName + '.pdf';
    }

    this.ds.readGuideFile(fileName).subscribe({
      next: blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
        this.dialogRef.close();
        this.done = true;
      },
      error: () => {
        this.done = true;
        this.dialogRef.close();
        this.dialog.open(ErrorPromptComponent, {
          data: {message: 'Guide introuvable'}
        });
      }
    });
  }
}
